export default {
  "--color-default": "rgb(0, 25, 79)",
  "--color-primary": "rgb(0, 25, 79)",
  "--color-primary-active": "rgb(0, 23, 75)",
  "--color-secondary": "rgb(249, 190, 60)",
  "--color-secondary-active": "rgb(248, 182, 35)",
  "--color-secondary-inverse": "rgb(0, 25, 79)",
  "--color-tertiary-active": "rgb(147, 7, 75)",
  "--color-success-active": "rgb(37, 165, 91)",
  "--color-danger-active": "rgb(214, 46, 46)",
  "--color-warning-active": "rgb(220, 116, 24)",
  "--color-yellow-active": "rgb(235, 188, 0)",
  "--text-color-link": "rgb(0, 25, 79)",
  "--text-color-link-active": "rgb(0, 23, 75)",
  "--text-color-primary": "rgb(0, 25, 79)",
  "--text-color-secondary": "rgb(249, 190, 60)",
  "--text-color-secondary-inverse": "rgb(0, 25, 79)",
  "--background-color-primary": "rgb(0, 25, 79)",
  "--background-color-primary-active": "rgb(0, 23, 75)",
  "--background-color-secondary": "rgb(249, 190, 60)",
  "--background-color-secondary-active": "rgb(248, 182, 35)",
  "--background-color-secondary-inverse": "rgb(0, 25, 79)",
  "--background-color-success-active": "rgb(37, 165, 91)",
  "--background-color-warning-active": "rgb(220, 116, 24)",
  "--background-color-danger-active": "rgb(214, 46, 46)",
  "--border-color-active": "rgb(0, 25, 79)",
  "--border-color-primary": "rgb(0, 25, 79)"
};